export const ALL_MODALS_HIDE = 'ALL_MODALS_HIDE';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const HIDE_BTN_CLOSE_IN_MODAL = 'HIDE_BTN_CLOSE_IN_MODAL';
export const SHOW_BTN_CLOSE_IN_MODAL = 'SHOW_BTN_CLOSE_IN_MODAL';
